import Checkbox from "@ls/react-checkbox";
import Input from "@ls/react-input";
import { MenuButton, MenuList } from "@ls/react-menu";
import { useCallback } from "react";
import Icon from "react-icons-kit";
import { ic_more_vert } from "react-icons-kit/md/ic_more_vert";
import { useDispatch, useSelector } from "react-redux";
import {
  setAppDecimal,
  setAppNameTitle,
  setAppTitle,
  setBandedRows,
  setDefaultExpansion,
  setGridFontSize,
  setGridHeaderHeight,
  setGridLevelLabels,
  setGridRowHeight,
  setGridVerticalLines,
  setHideGridSideBar,
  setListenScenarioAppTalk,
  setLoadDataOnLaunch,
  setShowGridLevelCount,
} from "state/app/actions";
import {
  selectAppDecimal,
  selectAppNameTitle,
  selectAppTitle,
  selectBandedRows,
  selectDefaultExpansion,
  selectGridFontSize,
  selectGridHeaderHeight,
  selectGridLevelLabels,
  selectGridRowHeight,
  selectGridVerticalLines,
  selectHideGridSideBar,
  selectListenScenarioAppTalk,
  selectLoadDataOnLaunch,
  selectShowGridLevelCount,
} from "state/app/selectors";
import styles from "./KebabMenu.module.css";

const urlParams = new URLSearchParams(window.location.search);
const hideGridBarOption = urlParams.get("hideGridBarOption") === "true"; //asked by Doug

const KebabMenu = (props) => {
  const dispatch = useDispatch();
  const appTitle = useSelector(selectAppTitle);
  const appNameTitle = useSelector(selectAppNameTitle);
  const appDecimal = useSelector(selectAppDecimal);
  const defaultExpansion = useSelector(selectDefaultExpansion);
  const bandedRows = useSelector(selectBandedRows);
  const gridVerticalLines = useSelector(selectGridVerticalLines);
  const gridFontSize = useSelector(selectGridFontSize);
  const gridRowHeight = useSelector(selectGridRowHeight);
  const hideGridSideBar = useSelector(selectHideGridSideBar);
  const gridHeaderHeight = useSelector(selectGridHeaderHeight);
  const loadDataOnLaunch = useSelector(selectLoadDataOnLaunch);
  const gridLevelLabels = useSelector(selectGridLevelLabels);
  const showGridLevelCount = useSelector(selectShowGridLevelCount);
  const listenScenarioAppTalk = useSelector(selectListenScenarioAppTalk);

  const onDecimalChange = useCallback(
    (val) => {
      dispatch(setAppDecimal(Number(val)));
    },
    [dispatch]
  );
  const onAppTitleChange = useCallback(
    (val) => {
      dispatch(setAppTitle(val));
    },
    [dispatch]
  );
  const onAppNameTitleChange = useCallback(
    (val) => {
      dispatch(setAppNameTitle(val));
    },
    [dispatch]
  );
  const onDefaultExpansionChange = useCallback(
    (val) => {
      dispatch(setDefaultExpansion(Number(val)));
    },
    [dispatch]
  );
  const onBandedRowsChange = useCallback(() => {
    dispatch(setBandedRows(!bandedRows));
  }, [bandedRows, dispatch]);
  const onGridVerticalLinesChange = useCallback(() => {
    dispatch(setGridVerticalLines(!gridVerticalLines));
  }, [gridVerticalLines, dispatch]);
  const onGridFontSizeChange = useCallback(
    (val) => {
      dispatch(setGridFontSize(Number(val)));
    },
    [dispatch]
  );
  const onGridRowHeightChange = useCallback(
    (val) => {
      dispatch(setGridRowHeight(Number(val)));
    },
    [dispatch]
  );
  const onChangeHideSideBar = useCallback(
    (val) => {
      dispatch(setHideGridSideBar(!val));
    },
    [dispatch]
  );
  const onGridHeaderHeightChange = useCallback(
    (val) => {
      dispatch(setGridHeaderHeight(Number(val)));
    },
    [dispatch]
  );
  const onChangeLoadDataOnLaunch = useCallback(
    (val) => {
      dispatch(setLoadDataOnLaunch(!val));
    },
    [dispatch]
  );
  const onChangeGridLevelLabels = useCallback(
    (val) => {
      dispatch(setGridLevelLabels(val));
    },
    [dispatch]
  );
  const onChangeGridLevelCount = useCallback(
    (val) => {
      dispatch(setShowGridLevelCount(val));
    },
    [dispatch]
  );
  const onListenScenarioAppTalkChange = useCallback(
    (val) => {
      dispatch(setListenScenarioAppTalk(val));
    },
    [dispatch]
  );


  return (
    <MenuButton
      buttonVariation={5}
      menuList={
        <MenuList>
          <div className={styles.item}>
            <Checkbox
              label={"Listen for Scenario AppTalk Messages"}
              value={listenScenarioAppTalk}
              onChange={onListenScenarioAppTalkChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Load up with no account"}
              value={!loadDataOnLaunch}
              onChange={onChangeLoadDataOnLaunch}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Show Bucket Level Labels"}
              value={gridLevelLabels}
              onChange={onChangeGridLevelLabels}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Show Bucket Level Children Count"}
              value={showGridLevelCount}
              onChange={onChangeGridLevelCount}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Show Banded Rows"}
              value={bandedRows}
              onChange={onBandedRowsChange}
            />
          </div>
          <div className={styles.item}>
            <Checkbox
              label={"Show Vertical Lines"}
              value={gridVerticalLines}
              onChange={onGridVerticalLinesChange}
            />
          </div>
          {!hideGridBarOption && (
            <div className={styles.item}>
              <Checkbox
                label={"Show Grid Side Bar"}
                value={!hideGridSideBar}
                onChange={onChangeHideSideBar}
              />
            </div>
          )}
          <div className={styles.item}>
            <Input
              label={"Grid font size:"}
              value={gridFontSize}
              onChange={onGridFontSizeChange}
              min={8}
              max={16}
              type={"number"}
              size={"S"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Grid header height:"}
              value={gridHeaderHeight}
              size={"S"}
              onChange={onGridHeaderHeightChange}
              min={0}
              max={150}
              type={"number"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Grid row height:"}
              value={gridRowHeight}
              onChange={onGridRowHeightChange}
              min={10}
              max={40}
              type={"number"}
              size={"S"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Default decimals:"}
              value={appDecimal}
              onChange={onDecimalChange}
              min={0}
              max={8}
              type={"number"}
              size={"S"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Default expansion level:"}
              value={defaultExpansion}
              onChange={onDefaultExpansionChange}
              min={1}
              max={8}
              type={"number"}
              size={"S"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"Title:"}
              value={appTitle}
              onChange={onAppTitleChange}
              size={"S"}
            />
          </div>
          <div className={styles.item}>
            <Input
              label={"App Name Override:"}
              value={appNameTitle}
              onChange={onAppNameTitleChange}
              size={"S"}
            />
          </div>
        </MenuList>
      }
      icon={<Icon icon={ic_more_vert} size={30} />}
      tooltip="Settings"
    />
  );
};

export default KebabMenu;
